import { render, staticRenderFns } from "./form-check.vue?vue&type=template&id=c3f5a920&scoped=true"
import script from "./form-check.vue?vue&type=script&setup=true&lang=js"
export * from "./form-check.vue?vue&type=script&setup=true&lang=js"
import style0 from "./form-check.vue?vue&type=style&index=0&id=c3f5a920&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f5a920",
  null
  
)

export default component.exports